import {
  ILineParams,
  IParamsToSend
} from '@base/@types/providers/Kpi/StorageProvider'

export const formatParamsModalKpiToSend = (
  dataLine: ILineParams,
  paramsToSend: IParamsToSend
) => {
  const paramsResponse = JSON.parse(
    localStorage.getItem('@kpiStorageParamsResponse:')
  )

  const storageIndicatorsRequestModal: IParamsToSend = {
    empresa: {
      ids: paramsToSend.empresa?.agrupar
        ? dataLine['empresa-codigo-id'] !== undefined
          ? [dataLine['empresa-codigo-id']]
          : paramsToSend.empresa?.ids
        : paramsToSend.empresa?.ids,
      agrupar: paramsToSend.empresa?.agrupar
    },
    tipoCentro: {
      ids: paramsToSend.tipoCentro?.agrupar
        ? (dataLine['cd-loja-tipo-id'] === 'Loja' && [0]) ||
          (dataLine['cd-loja-tipo-id'] === 'CD' && [1])
        : paramsToSend.tipoCentro?.ids,
      agrupar: paramsToSend.tipoCentro?.agrupar
    },
    loja: {
      ids: paramsToSend.loja?.agrupar
        ? dataLine['cd-loja-codigo-id'] !== undefined
          ? [dataLine['cd-loja-codigo-id']]
          : paramsToSend.loja?.ids
        : paramsToSend.loja?.ids,
      agrupar: paramsToSend.loja?.agrupar
    },
    gerenteCategoria: {
      ids: paramsToSend.gerenteCategoria?.agrupar
        ? dataLine['gerente-categoria-id'] !== ''
          ? [
              paramsResponse.find(
                (item: any) =>
                  item.gerenteCategoriaDescricao ===
                  dataLine['gerente-categoria-id']
              )?.gerenteCategoriaId
            ]
          : []
        : paramsToSend.gerenteCategoria?.ids,
      agrupar: paramsToSend.gerenteCategoria?.agrupar
    },
    gerenteProduto: {
      ids: paramsToSend.gerenteProduto?.agrupar
        ? dataLine['gerente-produto-id'] !== ''
          ? [
              paramsResponse.find(
                (item: any) =>
                  item.gerenteProdutoDescricao ===
                  dataLine['gerente-produto-id']
              )?.gerenteProdutoId
            ]
          : []
        : paramsToSend.gerenteProduto?.ids,
      agrupar: paramsToSend.gerenteProduto?.agrupar
    },
    mundo: {
      ids: paramsToSend.mundo?.agrupar
        ? dataLine['mundo-codigo-id'] !== undefined
          ? [dataLine['mundo-codigo-id']]
          : paramsToSend.mundo?.ids
        : paramsToSend.mundo?.ids,
      agrupar: paramsToSend.mundo?.agrupar
    },
    categoriaCompacta: {
      ids: paramsToSend.categoriaCompacta?.agrupar
        ? dataLine['categoria-compacta-codigo-id'] !== undefined
          ? [dataLine['categoria-compacta-codigo-id']]
          : paramsToSend.categoriaCompacta?.ids
        : paramsToSend.categoriaCompacta?.ids,
      agrupar: paramsToSend.categoriaCompacta?.agrupar
    },
    categoria: {
      ids: paramsToSend.categoria?.agrupar
        ? dataLine['categoria-codigo-id'] !== undefined
          ? [dataLine['categoria-codigo-id']]
          : paramsToSend.categoria?.ids
        : paramsToSend.categoria?.ids,
      agrupar: paramsToSend.categoria?.agrupar
    },
    statusEstoque: {
      ids: paramsToSend.statusEstoque?.agrupar
        ? dataLine['status-nome-id'] !== ''
          ? [
              paramsResponse.find(
                (item: any) =>
                  item.statusDescricao === dataLine['status-nome-id']
              )?.statusId
            ]
          : []
        : paramsToSend.statusEstoque?.ids,
      agrupar: paramsToSend.statusEstoque?.agrupar
    },
    curvaABC: {
      descricoes: paramsToSend.curvaABC?.agrupar
        ? dataLine['curva-abc-nome-id'] !== ''
          ? [dataLine['curva-abc-nome-id']]
          : []
        : paramsToSend.curvaABC?.descricoes,
      agrupar: paramsToSend.curvaABC?.agrupar
    },
    deposito: {
      ids:
        paramsToSend.deposito?.agrupar &&
        paramsToSend.deposito?.ids.length !== 0
          ? dataLine['deposito-codigo-id'] !== 0
            ? [dataLine['deposito-nome-id']]
            : []
          : paramsToSend.deposito?.ids,
      agrupar: paramsToSend.deposito?.agrupar
    },
    fornecedor: {
      ids: paramsToSend.fornecedor?.agrupar
        ? dataLine['fornecedor-id'] !== undefined
          ? [dataLine['fornecedor-id']]
          : paramsToSend.fornecedor?.ids
        : paramsToSend.fornecedor?.ids,
      agrupar: paramsToSend.fornecedor?.agrupar
    },
    subCategoria: {
      ids: paramsToSend.subCategoria?.agrupar
        ? [dataLine['subcategoria-codigo-id']]
        : paramsToSend.subCategoria?.ids,
      agrupar: paramsToSend.subCategoria?.agrupar
    },
    periodoVendaMedia: paramsToSend.periodoVendaMedia,
    CMVouEstoque: paramsToSend.CMVouEstoque,
    periodo: paramsToSend.periodo
  }

  return storageIndicatorsRequestModal
}
